import React, { useImperativeHandle, useState } from 'react';
import { Text, View, TouchableOpacity, Switch, Image } from 'react-native-web';
import PropTypes from 'prop-types';
import { showAlert } from '../utils/util_helpers';

import GLOBAL from '../configs/config_global';

export const SwitchView = React.forwardRef(({
    containerStyle,
    text,
    helpText,
    textStyle,
    switchColor,
    defaultState,
    toggleInFront
}, ref) => {
    const [isOn, setIsOn] = useState(defaultState);

    useImperativeHandle(ref, () => ({ getValue: () => isOn }), [isOn]);

    return(
        <View
            style={[{ alignSelf: 'stretch', flexDirection: toggleInFront ? 'row-reverse' : 'row', alignItems: 'center', marginTop: 16 }].concat(containerStyle)}>
            <View
                style={[
                    { flex: 1, flexDirection: 'row', alignItems: 'center' },
                    toggleInFront ? { marginLeft: 8 } : { marginRight: 8 }
                ]}>
                <Text style={[{ color: GLOBAL.COLOR.BASIC.BLACK_TWO }].concat(textStyle)}>
                    {text}
                </Text>

                {
                    !!helpText.trim() &&
                    <TouchableOpacity
                        style={{ marginLeft: 4 }}
                        onPress={() => showAlert({ text: helpText })}>
                        <Image source={require('../images/info.png')} style={{ width: 24, height: 24 }} />
                    </TouchableOpacity>
                }
            </View>

            <Switch
                value={isOn}
                trackColor={'#DEDEDE'}
                activeTrackColor={switchColor}
                activeThumbColor={'white'}
                thumbColor={'white'}
                onValueChange={(switchValue) => setIsOn(switchValue)}
            />
        </View>
    );
});

SwitchView.propTypes = {
    containerStyle: PropTypes.object,
    text: PropTypes.string,
    helpText: PropTypes.string,
    textStyle: PropTypes.object,
    onValueChange: PropTypes.func,
    switchColor: PropTypes.any,
    defaultState: PropTypes.bool,
    toggleInFront: PropTypes.bool
};

SwitchView.defaultProps = {
    containerStyle: {},
    text: '',
    helpText: '',
    textStyle: {},
    onValueChange: () => {},
    switchColor: GLOBAL.COLOR.BASIC.UI_GREEN,
    defaultState: false,
    toggleInFront: false
};
